module.exports = __webpack_public_path__ + "img/Not-Really-No.228e62a4.jpg";